
export interface ProposalResponseModel {
    proposalId: number;
    accountNumber?: string;
}

export const DefaultProposalResponse: ProposalResponseModel = {
    proposalId: 0
};
